<template>
    <c-dialog ref="dialog" title="请假单详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.document_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.document_number}}</label>
                <c-state dict="applyStatusDic" tag :value="detailData.status"></c-state>
            </div>
        </template>

        <doc-base>
			<template #title>{{detailData.applicant_name}}_请假单</template>

			<template #info>
				<c-field label="单据编号">{{detailData.document_number}}</c-field>
			</template>
        </doc-base>

        <doc-content>
            <c-field label="请假类型"><c-state dict="leaveTypeDic" :value="detailData.leave_type"></c-state></c-field>
            <c-field label="开始时间">
                <template v-if="detailData.leave_granularity == 1">{{detailData.start_time||detailData.start_date}}</template>
                <template v-if="detailData.leave_granularity == 2">{{detailData.start_time}}</template>

            </c-field>
            <c-field label="结束时间">
                <template v-if="detailData.leave_granularity == 1">{{detailData.end_time||detailData.end_date}}</template>
                <template v-if="detailData.leave_granularity == 2">{{detailData.end_time}}</template>
            </c-field>
            <c-field label="请假时长">
                <b>{{detailData.leave_duration}}{{detailData.leave_granularity == 2 ? '小时' : '天'}}</b>
            </c-field>
            <c-field label="请假事由">{{detailData.reason}}</c-field>
            <c-field label="图片">
                <c-file-list :value="detailData.attachment_images"></c-file-list>
            </c-field>
        </doc-content>

		<doc-log ref="docLog" :form-id="detailData.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			:order="id"
			:flow="4"
			:status="detailData.status"
			:applicant="detailData.is_founder == 1"
			:approver="detailData.is_approval == 1"
			@update="onHandleUpdate"
			@edit="editHandle"
			@delete="deleteHandle"
			@restart="restartHandle"
		></doc-handle>
		<leave-application-edit ref="leaveEdit" @resolve="onEditResolve"></leave-application-edit>
    </c-dialog>
</template>

<script>
import LeaveApplicationEdit from "@/pages/basic/leave_application_edit.vue";
export default {
    name: 'leaveApplicationDetail',
    components: {LeaveApplicationEdit},
    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.update();
            this.$refs.dialog.open();
        },

        onHandleUpdate() {
            this.update();
            this.$bus.$emit('leave_application_list.update');
        },

        editHandle() {
            this.$refs.leaveEdit.open(this.detailData);
        },

        restartHandle() {
            this.$refs.dialog.close();
            this.$nextTick(() => {
                this.$bus.$emit('leave_application_list.edit', {id: this.detailData.id});
            });
        },

        onEditResolve() {
            this.update();
            this.$bus.$emit('leave_application_list.update');
        },

        deleteHandle() {
            this.$confirm({
                message: '确认删除请假单【' + (this.detailData.document_number || this.detailData.id) + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/leave/application/delete',
                        data: {id: this.detailData.id},
                        loading: true,
                        success: () => {
                            this.$message({message: '删除成功', type: 'success'});
                            this.$refs.dialog.close();
                            this.$bus.$emit('leave_application_list.update');
                        }
                    });
                },
                cancel: () => {},
            });
        },

        update() {
            this.request({
                url: '/leave/application/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.$refs.docHandle.init(data.transaction);
                    // 手动刷新流程日志（同一条单据的 formId 不变时，watch 不会触发）
                    this.$refs.docLog && this.$refs.docLog.update();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
